import { render, staticRenderFns } from "./NonTouristVisa.vue?vue&type=template&id=64095f00&class=pa-0&"
import script from "./NonTouristVisa.vue?vue&type=script&lang=js&"
export * from "./NonTouristVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports